import { UserTypeAgnosticSettings } from './Types/UserTypeAgnosticSettings';

export enum SettingsActions {
    LOAD_SETTINGS = 'LOAD_SETTINGS',
    SET_SETTINGS = 'SET_SETTINGS',
    SET_ERROR = 'SET_ERROR',
}

export type SettingsActionTypes = {
    type: SettingsActions;
    payload?: UserTypeAgnosticSettings | { errorMessage: string };
};
